import React, { Component } from 'react'
import SystemLabelMasterCollection from 'collections/system_label_master_collection'

class SelectSuspension extends Component {

  handleChange = (e) => {
    this.props.actions.changeSelectSuspension({
      selectSuspension: e.target.value,
    })
  }

  render() {
    const { payload } = this.props.systemLabelMastersApi
    if (!payload) {
      return null
    }
    const systemLabelMasterCollection = new SystemLabelMasterCollection(payload)
    const { selectSuspension } = this.props
    return <div className='searchArea__item'>
      <h3 className='searchArea__title'>{TRUCKERS.LANG.ITEM.SUSPENSION}</h3>
      <p className='selectWrap searchArea__item__inner'>
        <select
          className="select"
          value={selectSuspension}
          onChange={this.handleChange}
        >
          <option value="">{TRUCKERS.LANG.ITEM.LIST_SEARCH.ALL}</option>
          {
            systemLabelMasterCollection.getValueList('item', 'suspension').map(i => {
              return <option key={i.get('label_key')} value={i.get('label_key')}>{i.getValueI18n()}</option>
            })
          }
        </select>
      </p>
    </div>
  }
}

export default SelectSuspension
